import React from 'react'
import { CheckboxWrapper, styles } from './styles';
import { Checkbox, InputLabel, makeStyles } from '@material-ui/core';
import Check from "@material-ui/icons/Check";
import { BLUE_RGB } from "utils/colorsTheme";


const useStyles = makeStyles(styles);

export const CedisInput = ( props ) => {
  const { cedis } = props
  const classes = useStyles();
  return (
    <CheckboxWrapper>
      <InputLabel
        // htmlFor="simple-select"
        className={classes.marginLabel}
      >
        Cedis
      </InputLabel>
      <Checkbox
        checkedIcon={<Check className={`${classes.checkedIconCustom}`} />}
        icon={<Check className={classes.uncheckedIconCustom} />}
        checked={cedis}
        style={{
          color: BLUE_RGB,
        }}
        classes={{
          checked: classes.checked,
          root: classes.checkRoot,
        }}
      />
    </CheckboxWrapper>
  )
}
